// Google Analytics utility functions

/**
 * Track page views
 * @param {string} path - The path to track
 */
export const trackPageView = (path) => {
  if (window.gtag) {
    window.gtag('config', process.env.REACT_APP_GA_MEASUREMENT_ID, {
      page_path: path,
    });
  }
};

/**
 * Track custom events
 * @param {string} category - Event category (e.g., 'Video', 'Button', 'Form')
 * @param {string} action - Event action (e.g., 'play', 'click', 'submit')
 * @param {string} label - Event label (optional)
 * @param {number} value - Event value (optional)
 */
export const trackEvent = (category, action, label = '', value = 0) => {
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

/**
 * Track button clicks
 * @param {string} buttonName - Name of the button clicked
 */
export const trackButtonClick = (buttonName) => {
  trackEvent('Button', 'click', buttonName);
};

/**
 * Track form submissions
 * @param {string} formName - Name of the form submitted
 */
export const trackFormSubmit = (formName) => {
  trackEvent('Form', 'submit', formName);
};

/**
 * Track file uploads
 * @param {string} fileType - Type of file uploaded (e.g., 'audio', 'video', 'document')
 */
export const trackFileUpload = (fileType) => {
  trackEvent('Upload', 'file_upload', fileType);
};

/**
 * Track feature usage
 * @param {string} featureName - Name of the feature used
 */
export const trackFeatureUse = (featureName) => {
  trackEvent('Feature', 'use', featureName);
};

/**
 * Track language changes
 * @param {string} language - The language selected (e.g., 'en', 'ar')
 */
export const trackLanguageChange = (language) => {
  trackEvent('Language', 'change', language);
};

/**
 * Track external link clicks
 * @param {string} url - The external URL clicked
 */
export const trackExternalLink = (url) => {
  trackEvent('External Link', 'click', url);
};
